export default function () {
  return {
    methods: {
      // 力软提供方法
      columnText(index, row, column, scope) {
        if (typeof column.formatter == "function") {
          return column.formatter({
            row: row,
            column: scope.column,
            cellValue: row[column.prop],
            index: index,
          });
        } else {
          this.loadCellData(row[column.prop], column);
          return this.getCellText(row[column.prop], column);
        }
      },
      loadCellData(value, { dataType, dataCode }) {
        if (dataType && value) {
          switch (dataType) {
            case "dataItem":
              this.lr_loadDataItem && this.lr_loadDataItem(dataCode);
              break;
            case "dataSource":
              this.lr_loadDataSourceData &&
                this.lr_loadDataSourceData(dataCode);
              break;
            case "company":
              this.lr_loadCompanys && this.lr_loadCompanys();
              break;
            case "department":
              this.lr_loadDepartment && this.lr_loadDepartment(value);
              break;
            case "role":
              this.lr_loadRole && this.lr_loadRole(value);
              break;
            case "post":
              this.lr_loadPost && this.lr_loadPost(value);
              break;
            case "user":
              this.lr_loadUsers && this.lr_loadUsers(value);
              break;
            case "areas":
              if (this.lr_loadAreas) {
                const areaList = value.split(",");
                if (areaList.length == 3) {
                  this.lr_loadAreas(0),
                    this.lr_loadAreas(areaList[0]),
                    this.lr_loadAreas(areaList[1]);
                }
              }
              break;
          }
        }
      },
      getCellText(
        value,
        { dataType, dataCode, options, valueKey, labelKey, format }
      ) {
        if (window.$validatenull(value)) {
          return "";
        }
        if (!this.lr_dataSourceName) {
          return value;
        }
        switch (dataType) {
          case "mydata": {
            const dataSource = [];
            this.findTreeItem(options, dataSource); //静态数据
            return this.lr_dataSourceName(
              dataSource,
              value,
              "value",
              "label",
              this.$uuid()
            );
          }
          case "dataItem":
            return this.lr_dataItemName(this.lr_dataItem[dataCode], value);
          case "dataSource":
            return this.lr_dataSourceName2(dataCode, value, valueKey, labelKey);
          case "datetime":
            return window.$formatDate(value, format || "yyyy-MM-dd hh:mm:ss");
          case "company":
            return this.lr_loadCompanyName(value);
          case "department":
            return this.lr_departmentNameByOne(value);
          case "role":
            return (this.lr_role[value] || {})[labelKey || "f_FullName"] || "";
          case "post":
            return (this.lr_post[value] || {})[labelKey || "f_FullName"] || "";
          case "user":
            return this.lr_userName(value);
          case "fullUser":
            return this.lr_fullUser(value);
          case "areas":
            return this.lr_areasName(value);
          case "secretLevel":
            if (value == 0) return "公开";
            else if (value == 1) return "内部";
            else if (value == 2) return "秘密";
            else if (value == 3) return "机密";
            else return "绝密";
          default:
            return value;
        }
      },
      findTreeItem(arr, res) {
        arr.forEach((t) => {
          res.push({ value: t.value, label: t.label });
          if (t.children) {
            this.findTreeItem(t.children, res);
          }
        });
      },
    },
  };
}
